// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"MP-z","upvoteIcon":"NP-z","downvoteIcon":"OP-z","feedbackIcon":"PP-z"};